/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".view-toolbar{position:absolute;display:inline-block;z-index:20;bottom:0;left:50%}.view-toolbar-inner{position:relative;left:-50%}"];
export { styles as styles };
